/* ============================================================
   gs-atc.js — "Agregar al carrito" en las cards del PLP gs +
   apertura del cart-drawer lateral al completar cada 3 productos.

   Se carga SOLO cuando la sección gs-collection tiene
   show_add_to_cart activo (opt-in por template). Aislado: no
   toca gs-plp.js ni otras colecciones.

   Patrón validado en los kit-builders de Serené:
   - POST /cart/add.js con sections='cart-icon-bubble,cart-drawer'
   - refresco server-rendered preservando la clase `active` del
     drawer (solo se togglea `is-empty`)
   - cola anti-race: serializa los add para no pisar el snapshot
     del drawer al tocar varias cards seguidas
   - drawer.open() dentro de requestAnimationFrame
   ============================================================ */
(function () {
  'use strict';

  // Umbral configurable por template: la sección gs-collection expone
  // data-gs-atc-open-at en su raíz (.gs-collection). Default 3 (50 ml).
  // 100 ml (oferta escalonada) usa 2. Se abre el drawer cada N agregados.
  function getOpenEvery() {
    var host = document.querySelector('.gs-collection[data-gs-atc-open-at]');
    var n = host ? parseInt(host.getAttribute('data-gs-atc-open-at'), 10) : 3;
    return (n && n > 0) ? n : 3;
  }
  var addedCount = 0;

  /* ---- Cola anti-race: cada /cart/add.js espera al anterior ---- */
  var queue = Promise.resolve();
  function enqueue(job) {
    var next = queue.then(job, job);
    queue = next.catch(function () {});
    return next;
  }

  /* ---- Refresca cart-icon-bubble + cart-drawer sin cerrar el drawer ---- */
  function refreshSections(data) {
    if (!data || !data.sections) return;

    if (data.sections['cart-icon-bubble']) {
      var pb = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
      var tb = document.getElementById('cart-icon-bubble');
      var sb = pb.querySelector('#shopify-section-cart-icon-bubble') || pb.querySelector('.shopify-section');
      if (tb && sb) tb.innerHTML = sb.innerHTML;
    }

    if (data.sections['cart-drawer']) {
      var pd = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
      var td = document.querySelector('cart-drawer');
      var sd = pd.querySelector('cart-drawer');
      if (td && sd) {
        // CRÍTICO: NO copiar className completo (perdería `active` = drawer abierto).
        // Solo togglear `is-empty`, que es lo único que depende del contenido.
        td.classList.toggle('is-empty', sd.classList.contains('is-empty'));
        td.innerHTML = sd.innerHTML;
      }
    }
  }

  /* ---- ¿El drawer ya está abierto? (para no re-abrir en cada add) ---- */
  function drawerIsOpen() {
    var d = document.querySelector('cart-drawer');
    return !!(d && (d.classList.contains('active') || d.classList.contains('animate')));
  }

  /* ---- Abre el drawer lateral (usa la API nativa del custom element) ---- */
  function openDrawer() {
    requestAnimationFrame(function () {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
      // Fallback defensivo por si el custom element no expone open()
      if (drawer) {
        drawer.classList.remove('is-empty');
        drawer.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
      }
    });
  }

  /* ---- Agregar 1 unidad de la variante de la card ---- */
  function addToCart(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.disabled || btn.classList.contains('is-loading')) return;

    var label = btn.querySelector('.gs-card__atc-label');
    var original = label ? label.textContent : 'Agregar al carrito';
    btn.classList.add('is-loading');
    if (label) label.textContent = 'Agregando…';

    enqueue(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: 'cart-icon-bubble,cart-drawer'
        })
      }).then(function (res) {
        if (!res.ok) {
          return res.json().catch(function () { return {}; }).then(function (e) {
            throw new Error(e.description || ('cart/add HTTP ' + res.status));
          });
        }
        return res.json();
      }).then(function (data) {
        refreshSections(data);
      });
    }).then(function () {
      addedCount++;
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      if (label) label.textContent = '✓ Agregado';
      setTimeout(function () {
        btn.classList.remove('is-added');
        if (label) label.textContent = original || 'Agregar al carrito';
      }, 1400);

      // Al alcanzar el umbral se despliega el carrito lateral. Si el cliente
      // agrega más (p.ej. va del 2º al 3º en la oferta escalonada 100 ml) y ya
      // había cerrado el drawer, vuelve a abrirse. Si ya está abierto, no hace
      // nada (evita reaperturas redundantes / sensación de bug).
      if (addedCount >= getOpenEvery() && !drawerIsOpen()) openDrawer();
    }).catch(function (err) {
      console.error('[gs-atc]', err);
      btn.classList.remove('is-loading');
      if (label) label.textContent = 'Reintentar';
      setTimeout(function () {
        if (label) label.textContent = original || 'Agregar al carrito';
      }, 1600);
    });
  }

  /* ---- Delegación: sobrevive el re-render de facetas (Dawn reemplaza el grid) ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-gs-atc]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    addToCart(btn);
  });
})();
